<!-- 小结 -->
<template>
  <div class="TableMessage" ref="smsDOM">
    <div class="search-container">
      <div class="search-item">
        <a-select
          v-model:value="queryParam.sendStatus"
          placeholder="选择发送状态"
          style="width: 224px"
          size="large"
          allowClear
          :options="messageTypeMap"
        />
      </div>
      <div class="search-item">
        <a-range-picker
          size="large"
          v-model:value="dateList"
          :placeholder="['开始日期', '结束日期']"
          allowClear
          format="YYYY-MM-DD"
          :ranges="rangePresets"
          dropdownClassName="creatTime"
          :disabledDate="disabledDate"
        />
      </div>
      <div class="search-item">
        <a-button class="search-button" size="large" type="primary" @click="searchList">
          搜索
        </a-button>
      </div>
    </div>
    <a-table
      class="my-table"
      :bordered="true"
      :transformCellText="({ text }) => text ?? '--'"
      :pagination="pagination"
      :dataSource="dataSource"
      :columns="col"
      rowKey="id"
      @change="change"
      :loading="loading"
      :scroll="{ y: 300 }"
    >
      <template #sendPerson="{ record }">
        <RoleTag :role="record.sendPersonRole">
          {{ record.sendPerson }}
        </RoleTag>
      </template>
      <template #receivePerson="{ record }">
        <RoleTag :role="record.receivePersonRole">
          {{ maskPatientName(record.receivePerson, record.receivePersonRole) }}
        </RoleTag>
      </template>
      <template #sendStatus="{ record }">
        <a-tag v-if="record.sendStatus" color="success">发送成功</a-tag>
        <a-tag v-else color="error">发送失败</a-tag>
      </template>
      <template #smsInfo="{ text }">
        <a-tooltip
          :getPopupContainer="() => smsDOM"
          overlayClassName="my-tooltip"
          placement="bottom"
          class="two-line"
        >
          <template #title>{{ text }}</template>
          <div class="tooltip-body">
            {{ text }}
          </div>
        </a-tooltip>
      </template>
    </a-table>
  </div>
</template>

<script setup>
import { getSMSInfo } from '@/api/workPlace/SMS'
import { ColMessage as col } from '@/components/PatientFile/config'
import { computed, onMounted, ref } from 'vue'
import RoleTag from '@/views/WorkPlace/Container/SMS/RoleTag.vue'
import { maskPatientName } from '@/utils'

import { useStore } from 'vuex'
import {
  messageTypeMap,
  messageTimeMap,
  getTimeRange,
  rangePresets,
  disabledDate,
  formatDateForFilter
} from '@/components/PatientFile/ModalBody/tags/PlatformService/config'
const store = useStore()
const ucPatientId = computed(() => store.state.patientFile.info.ucPatientId)
const info = computed(() => store.state.patientFile.info)
const patientType = computed(() => store.state.patientFile.patientType)
const smsDOM = ref()
const dataSource = ref([])
const loading = ref(false)
const dateList = ref([])
const pagination = ref({
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
})
const queryParam = {
  sendStatus: ''
}
const searchList = () => {
  getData()
}
const getData = async () => {
  const query = {
    pageSize: pagination.value.pageSize,
    pageNo: pagination.value.current,
    patientUcId: patientType.value ? ucPatientId.value : null,
    prePatientId: patientType.value === 0 ? info.value.prePatientId : null,
    ...queryParam
  }
  const [startTime, endTime] = formatDateForFilter(dateList.value)
  query.sendStartTime = startTime
  query.sendEndTime = endTime
  dataSource.value = []
  loading.value = true
  getSMSInfo(query)
    .then(result => {
      const { list, totalCount } = result
      dataSource.value = list
      pagination.value.total = totalCount
      pagination.value.showTotal = () => `共${totalCount}条`
    })
    .catch(err => {})
    .finally(() => {
      loading.value = false
    })
}
const change = page => {
  pagination.value.current = page?.current || 1
  pagination.value.pageSize = page?.pageSize || 10
  getData()
}
onMounted(() => {
  change()
})
</script>

<style lang="scss" scoped>
.TableMessage {
  .search-container {
    // padding: 10px 20px 0 0;
    background-color: #ffffff;
    .search-item {
      display: inline-block;
      margin-bottom: 10px;
      margin-right: 12px;
      .search-input {
        width: 224px;
      }
    }
  }
  ::v-deep(.my-table) {
    .two-line {
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  // 黑色弹出的提示内容框 样式
  ::v-deep(.my-tooltip) {
    .ant-tooltip-content {
      .ant-tooltip-inner {
        border-radius: 4px;
      }
    }
  }
}
</style>
